import { getNewsFromApi, getNewsFromCms } from './connector';

export interface NewsQuery {
	rootId: number;
	limit: number;
	offset: number;
	preview?: boolean;
	previewData?: Content.PreviewData;
}

export const getNews = async ({ rootId, limit, offset, preview, previewData }: NewsQuery): Promise<News.NewsArticle[]> => {
	if (typeof window === 'undefined') {
		//Server side
		return await getNewsFromCms(rootId, limit, offset, preview, previewData);
	} else {
		//Client side
		return await getNewsFromApi(rootId, limit, offset, preview, previewData);
	}
};
